import {ID_DELIMITER} from './ID_DELIMITER';

export const buildDroppableItemId = (id: string) => ['droppable', id].join(ID_DELIMITER);
